import React from 'react'
import { Box } from '@mui/material'
import { alpha } from '@mui/material/styles'

import { poolwerxColors } from '../../../../../theme/colors'
import { fmtInt } from '../../../../../config/tools/productCatalogueReview/formatters'

export type PillVariant = 'neutral' | 'warning' | 'danger'

const PILL_STYLES: Record<PillVariant, { bg: string; fg: string }> = {
  neutral: { bg: poolwerxColors.grey[100], fg: poolwerxColors.grey[700] },
  warning: { bg: alpha(poolwerxColors.warning, 0.16), fg: '#7a4500' },
  danger: { bg: alpha(poolwerxColors.error, 0.12), fg: '#8e0000' },
}

interface CountPillProps {
  count: number
  variant: PillVariant
}

const CountPill: React.FC<CountPillProps> = ({ count, variant }) => {
  const { bg, fg } = PILL_STYLES[variant]
  return (
    <Box
      component="span"
      sx={{
        ml: 0.75,
        px: 0.75,
        py: 0.1,
        borderRadius: 999,
        bgcolor: bg,
        color: fg,
        fontWeight: 700,
        fontSize: '0.68rem',
        lineHeight: 1.5,
        minWidth: 20,
        textAlign: 'center',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {fmtInt(count)}
    </Box>
  )
}

export default CountPill
